import { gql } from '@apollo/client';

export const GET_PATIENT_PHARMACISTS = gql`
  query getPatientById($data: PatientIdField!) {
    getPatientById(data: $data) {
      secondaryPharmacistId
    }
  }
`;
